import React from "react";
import Modal from "react-modal";
const customStyles = {
  content: {
    width: "350px",
    height: "400px",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    borderRadius: "20px",
  },
};

Modal.setAppElement("#root");

const PopupCard = ({ modalIsOpen, closeModal, card }) => {
  function afterOpenModal() {}
  const { author, content, thumbnail, title } = card;
  const { name, avatar } = author;
  const { large } = thumbnail;
  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="close-modal" onClick={() => closeModal()}>
          {" "}
          X{" "}
        </div>
        <div style={{minHeight: "360px"}} className="card">
          <div className="card-modal-image">
            <img src={large} alt="small" width="100%" height="180px" />
          </div>
          <div className="card-body">
            <div className="card-title" >
              <h2>{title}</h2>
            </div>
            <div className="card-description">
              <p>{content}</p>
            </div>
            <div className="card-footer">
              <img src={avatar} alt="" height="40px" width="40"></img>
              <small>21th February, 2021</small>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default PopupCard;
